/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from 'react';

import './ExploreMapFlyoutDetail.scss';

import ExploreMapFlyoutDetailNoSelection from './ExploreMapFlyoutDetailNoSelection';
import ExploreMapFlyoutDetailSelectedProductClustered from './ExploreMapFlyoutDetailSelectedProductClustered';
import ExploreMapFlyoutDetailSelectedProductRecord from './ExploreMapFlyoutDetailSelectedProductRecord';
import ExploreMapFlyoutDetailSelectedImportListLocation from './ExploreMapFlyoutDetailSelectedImportListLocation';
import ExploreMapFlyoutDetailSelectedImportListContact from './ExploreMapFlyoutDetailSelectedImportListContact';
import ExploreMapFlyoutDetailSelectedImportListCompany from './ExploreMapFlyoutDetailSelectedImportListCompany';
import ExploreMapFlyoutDetailSelectedSupplier from './ExploreMapFlyoutDetailSelectedSupplier';

export default function ExploreMapFlyoutDetail(props) {
    const {
        exploreMapFlyoutDetailMode,
        exploreMapMode,
        selectedPoint
    } = props;

    if (exploreMapFlyoutDetailMode === 'NONE') {
        return <ExploreMapFlyoutDetailNoSelection />
    }

    if (exploreMapFlyoutDetailMode === 'OVERLAY' && selectedPoint?.type === 'OVERLAY') {
        return <ExploreMapFlyoutDetailSelectedImportListLocation {...props} />
    }

    if (
        exploreMapMode === 'ADDRESS' &&
        exploreMapFlyoutDetailMode === 'UNCLUSTERED' &&
        selectedPoint?.type === 'OVERLAY'
    ) {
        const listType = selectedPoint.properties?.listType;

        if (listType === 'IMPORT_COMPANY') {
            return <ExploreMapFlyoutDetailSelectedImportListCompany {...props} />
        }

        if (listType === 'IMPORT_CONTACT') {
            return <ExploreMapFlyoutDetailSelectedImportListContact {...props} />
        }

        if (listType === 'SUPPLIER') {
            return <ExploreMapFlyoutDetailSelectedSupplier {...props} />
        }
    }

    if (exploreMapFlyoutDetailMode === 'PRODUCT_DATA_CLUSTERED' && selectedPoint?.type === 'PRODUCT') {
        return <ExploreMapFlyoutDetailSelectedProductClustered {...props} />
    }

    if (exploreMapFlyoutDetailMode === 'PRODUCT_DATA_RECORD_POINT' && selectedPoint?.type === 'PRODUCT') {
        return <ExploreMapFlyoutDetailSelectedProductRecord {...props} />
    }

    return null;
}
